import { render, staticRenderFns } from "./UtilityTypeAdmin.vue?vue&type=template&id=5e88d048&scoped=true"
import script from "./UtilityTypeAdmin.vue?vue&type=script&lang=js"
export * from "./UtilityTypeAdmin.vue?vue&type=script&lang=js"
import style0 from "./UtilityTypeAdmin.vue?vue&type=style&index=0&id=5e88d048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e88d048",
  null
  
)

export default component.exports